import { createContext, useContext, useState } from 'react';

interface BillingContextType {
  paymentIntentId?: string | null;
  setPaymentIntentId: (paymentIntentId: string | undefined | null) => void;
}

const BillingContext = createContext<BillingContextType | undefined>(undefined);

export const BillingProvider = ({ children }: { children: React.ReactNode }) => {
  const [paymentIntentId, setPaymentIntentId] = useState<string | undefined | null>(undefined);

  return (
    <BillingContext.Provider value={{ paymentIntentId, setPaymentIntentId }}>
      {children}
    </BillingContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useBillingContext = () => {
  const context = useContext(BillingContext);
  if (!context) {
    throw new Error('useBillingContext must be used within a BillingProvider');
  }
  return context;
};
